
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { State } from "vuex-class";
import { getMerchantCurve } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
@Component
export default class PiHometomorrowPowerData extends Vue {
  @State("sys") sys!: objAny;
  @Watch("sys.winOnresize")
  getVisible() {
    this.resizeBox();
  }
  @Prop({ default: "" }) private title!: string;

  private tomorrowPowerEchart: objAny = {};
  private tabs = [
    {
      label: i18n.t("unitText.day"),
      value: 1
    },
    {
      label: i18n.t("unitText.month"),
      value: 2
    },
    {
      label: i18n.t("unitText.year"),
      value: 3
    }
  ];
  private type = 1;
  public dayStr = this.$common.userDate(new Date(), "yyyy-MM");
  public monthStr = this.$common.userDate(new Date(), "yyyy");
  private selected = this.dayStr + "";
  public typeChange(value: number) {
    if (this.type === value) return;
    this.selected =
      value === 1 ? this.dayStr + "" : value === 2 ? this.monthStr + "" : "";
    this.type = value;
    this.getMerchantCurve();
  }
  public timeChange(value: string) {
    this.selected = value;
    this.getMerchantCurve();
  }
  private last5Year = i18n.t("last5Year");
  private tomorrowPowerData: objAny = {};
  private myChart: objAny = {};
  private win: objAny = window;

  public resizeBox(): void {
    if (this.myChart.id) {
      this.myChart.resize();
    }
  }
  public init(): void {
    const nameArr: string[] = [];
    const valueArr: number[] = [];

    this.tomorrowPowerData.map((item: objAny) => {
      nameArr.push(item.name);
      valueArr.push(item.value);
    });
    const option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "10%",
        containLabel: true
      },
      xAxis: [
        {
          type: "category",
          data: nameArr,
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: [
        {
          name: i18n.t("home.order"),
          type: "value"
        }
      ],
      series: [
        {
          name: i18n.t("home.order"),
          barWidth: "60%",
          data: valueArr,
          type: "line"
        }
      ]
    };
    this.myChart = this.win.echarts.init(this.tomorrowPowerEchart);
    this.myChart.clear();
    this.myChart.setOption(option, true);
  }
  async getMerchantCurve(): Promise<void> {
    const ret = await getMerchantCurve({
      type: this.type,
      selected: this.selected
    });
    if (ret.status === this.$config.apiStatus) {
      if (ret.data.length > 0) {
        this.tomorrowPowerData = ret.data;
      } else {
        this.tomorrowPowerData = [];
      }

      this.init();
    }
  }

  mounted() {
    this.$nextTick(() => {
      this.tomorrowPowerEchart = this.$refs["tomorrowPowerEchart"];
      this.getMerchantCurve();
    });
  }
}
